import { GlobalStore, GridStore } from '@roc/feature-app-core';
import {
  GENERIC_ERROR_MESSAGE,
} from '@roc/feature-utils';
import { GeneralTasksService } from '../services/generalTasksService';
import {
  ResultType,
  TaskScope,
  TaskStatus,
} from '../types/generalTasksTypes';
import { SupportTasksStore } from './supportTasksStore';

export class SupportTasksGridStore extends GridStore {
  globalStore: GlobalStore;
  supportTasksStore: SupportTasksStore;
  generalTasksService: GeneralTasksService;

  constructor(globalStore: GlobalStore, supportTasksStore: SupportTasksStore, status?: TaskStatus) {
    super(() => this.fetchSupportTasksByStatus(status));
    this.globalStore = globalStore;
    this.supportTasksStore = supportTasksStore;
    this.supportTasksStore.setApplyFiltersCallback(() => { this.resetAndFetchGridData(); });
    this.generalTasksService = new GeneralTasksService();
  }

  fetchSupportTasksByStatus = async status => {
    try {
      return await this.fetchMySupportTasksGrid(status);
    } catch (error) {
      this.globalStore.notificationStore.showErrorNotification({
        message: GENERIC_ERROR_MESSAGE,
      });
    }
  }

  fetchMySupportTasksGrid = async (status) => {
    const { filters, dropdownFilters } = this.supportTasksStore.getFilterParams();
    return this.generalTasksService.getMyTasksGrid(
      null,
      status,
      this.gridData.meta.pageNumber,
      this.gridData.meta.pageSize,
      this.gridData.meta.sortDir,
      this.gridData.meta.sortBy,
      filters,
      dropdownFilters,
      null,
      TaskScope.REPORTED_BY_ME,
      ResultType.ALL_TASKS,
      null,
      this.supportTasksStore.showCompletedInLastThirtyDays,
    );
  }
}
